module.exports = __webpack_public_path__ + "img/4.8fb7f00b.png";